import { UUID } from '../common';
import { EVehicleType } from './vehicle-type.enum';

export interface IVehicle {
  id: UUID;
  plateNumber: string;
  type: EVehicleType;
}

/**
 * Vehicle types accepted for a vehicle. Any other value coming from the backend is ignored.
 * - TRACTOR: cabeza tractora
 * - CANVAS: remolque
 * - BOX: caja cerrada
 */
export const managedVehicleTypes: ReadonlySet<EVehicleType> = new Set([
  EVehicleType.TRACTOR,
  EVehicleType.CANVAS,
  EVehicleType.BOX,
]);

export function isManagedVehicleType(value: unknown): value is EVehicleType {
  return typeof value === 'string' && managedVehicleTypes.has(value as EVehicleType);
}
